import Panzoom from '@panzoom/panzoom'
import Alpine from "alpinejs";

Alpine.data("pageImageApp", () => ({
    
    imageInit() {
        this.imageContainer = document.querySelector('.c-book-container__image-zoom-container');
        this.image = this.imageContainer.querySelector('img');
        const containerWidth = this.imageContainer.clientWidth;

        this.panzoom = Panzoom(this.image, {
            maxScale: 3,
            minScale: 1,
            bounds: true,
            boundsPadding: 0.1,
            startX: containerWidth / 4,
            startY: 0,
        });

        this.imageContainer.addEventListener('wheel', (event) => {
            event.preventDefault();
            this.panzoom.zoomWithWheel(event);
        });

        this.image.addEventListener('panzoomchange', () => {
            const scale = this.panzoom.getScale().toFixed(2);
            const slider = document.getElementById('zoomSlider');
            if (slider) {
                slider.value = scale;
            }
            this.zoomValue = scale;
        });
    },
    zoomIn() {
        if (this.panzoom) {
            const current = this.panzoom.getScale();
            const next = Math.min(parseFloat((current + 0.3).toFixed(2)), 3);
            this.panzoom.zoom(next, { animate: true });
        }
    },
    zoomOut() {
        if (this.panzoom) {
            const current = this.panzoom.getScale();
            const next = Math.max(parseFloat((current - 0.3).toFixed(2)), 1);
            this.panzoom.zoom(next, { animate: true });
        }
    },
    updateSlider() {
        const scale = this.panzoom.getScale().toFixed(2);
        const slider = document.getElementById('zoomSlider');
        if (slider) slider.value = scale;
        this.zoomValue = scale;
    },
    destroy() {
        if (this._resizeObserver) this._resizeObserver.disconnect();
        if (this.panzoom) this.panzoom.destroy();
    },
    panzoom: null,
    imageContainer: null,
    image: null,
    _resizeObserver: null,
    open: true,
    zoomValue: 1,
}));